module.exports = __webpack_public_path__ + "static/media/Milho.3b1890a6.png";